module.exports = __webpack_public_path__ + "./images/40c9208f5f2811de355633f0092d364a.webp";